import { SignInData, SignOutData, SignUpData } from "../../types/auth.dto";
import {
  SignIn,
  SignOut,
  SIGN_IN,
  SIGN_OUT,
  AUTO_SIGN_IN,
  RESET_SIGN_IN,
  RESET_SIGN_UP,
  SIGN_UP,
  SignUp,
  RecoverPassword,
  RECOVER_PASSWORD,
  ResetPassword,
  RESET_PASSWORD,
    SIGN_IN_WITH_SOCIAL,
  SIGN_UP_WITH_SOCIAL
} from "../types/auth";

export const signIn = (value: SignInData): SignIn => {
  return { type: SIGN_IN, payload: value };
};

export const signInSocial = (payload)=>{
  return {type:SIGN_IN_WITH_SOCIAL,payload}
}

export const signUpSocial = (payload)=>{
  return {type:SIGN_UP_WITH_SOCIAL,payload}
}

export const signOut = (value: SignOutData = {}): SignOut => {
  return { type: SIGN_OUT, payload: value };
};

export const autoSignIn = () => {
  return { type: AUTO_SIGN_IN, payload: null };
};

export const resetSignIn = () => {
  return { type: RESET_SIGN_IN, payload: null };
};
export const resetSignUp = () => {
  return { type: RESET_SIGN_UP, payload: null };
};

export const signUp = (value: SignUpData): SignUp => {
  return { type: SIGN_UP, payload: value };
};

export const recoverPassword = (payload: {
  email: string;
}): RecoverPassword => {
  return { type: RECOVER_PASSWORD, payload };
};

export const resetPassword = (payload: {
  id: string;
  password: string;
}): ResetPassword => {
  return { type: RESET_PASSWORD, payload };
};
